// Dependencies
import { h, Component } from 'preact';
import {connect} from 'react-redux'


// Components
import WidgetComponent from 'components/WidgetComponent'
import {Form, Button, I18n, Col, Container, Row, FormEntry} from 'components/elements'

// Actions
import {AccountActions, PageActions, SessionActions} from 'actions'
import LoadingActions from "actions/LoadingActions";


// Style
import style from './index.less'

// Icons
import showIcon from "../../../assets/icons/svg/eye.svg";
import hideIcon from "../../../assets/icons/svg/eye_off.svg";

// Class Component
@Form
@connect((state)=> state)
export default class Login extends WidgetComponent {

    // Constructor
    constructor(props, context){
        super(props, context)
        this.state = {
            passwordError: false,
            accountLocked: false,
            emailError: false,
            showPassword: false,
            value: ''
        }
        this.handlePasswordResetPrompt = this.handlePasswordResetPrompt.bind(this)
        this.handleLogin = this.handleLogin.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleShowPassword = this.handleShowPassword.bind(this)
    }

    // Getters
    get loginSpinner(){
        return this.props.loading.Login
    }

    // Methods
    handleLogin(data){
        this.componentWillSubmit().then(()=>{
            LoadingActions.append({Login: true});
            data.email = this.props.session.account.email
            data.mobilePhone = this.props.session.account.mobilePhone
            AccountActions.authenticate(data).then((response)=>{
                PageActions.navToFilters()
                this.componentDidSubmit()
            })
            .catch((e)=>{
                LoadingActions.append({Login: false});
                this.componentFailedToSubmit()
                if(String(Object(e.response.data).error).includes("is currently locked, come back later and try again.")){
                    this.setState({
                        accountLocked: true,
                        passwordError: false
                    })
                } else {
                    this.setState({
                        passwordError: true
                    })
                }
            })
        })
    }

    handlePasswordResetPrompt(type){
        SessionActions.setAuthenticationMode(type)
        PageActions.navToResetPasswordPrompt()
    }
    
    handleChange(e){

        if(this.state.passwordError){
            this.setState({
                passwordError: false
            })
        }
        if(e.target.name == 'value'){
            this.setState({
                value: e.target.value,
                emailError: false
            })
        }
    }

    handleShowPassword(){
        this.setState({
            showPassword: !this.state.showPassword
        })
    }

     // Render Component
    render(){
        const {InputDark, Form} = this.props
        return (
            <Form class={style.login} onSubmit={this.handleLogin}>
                <Container class={`${this.props.class || ""} ${style.containerView || ""}`}>
                    <Row class={style.firstItem}>
                        <Col span={{sm: 24}} class={style.noPadding}> 
                            <div className={style.passwordInputContainer}>
                                <label>
                                    <I18n>enterYourPassword</I18n>
                                </label>
                                <div class={style.item}>
                                    <button className={style.showPasswordBtn} type="button" class={style.passwordButton} onClick={this.handleShowPassword}>
                                        <img src={this.state.showPassword ? hideIcon : showIcon} alt='Show Password'/>
                                    </button>
                                    <FormEntry>
                                        <InputDark 
                                            onChange={this.handleChange} 
                                            required={true} 
                                            name='password' 
                                            question={I18n.t('password')} 
                                            type={this.state.showPassword ? "text" : "password"} 
                                        />
                                    </FormEntry>
                                </div>
                            </div>
                            <div className={style.helpInstructions}>
                                <div>
                                    <I18n>forgotYourPassword</I18n>
                                    <div style={{display: "inline", paddingLeft: "5px"}} class={style.resetPassword} onClick={this.handlePasswordResetPrompt.bind(null,'reset')}><I18n>resetPassword</I18n></div>
                                </div>
                                <div>
                                    <I18n>firstTimeLogin</I18n>
                                    <div style={{display: "inline", paddingLeft: "5px"}} class={style.resetPassword} onClick={this.handlePasswordResetPrompt.bind(null,'claim')}><I18n>claimAccount</I18n></div>
                                </div>
                            </div>
                            <div class={style.errorContainer}>
                                {this.state.accountLocked && 
                                    <div class={style.errorMessage}><I18n>LoginErrorLockedAccount</I18n></div>
                                }
                                {this.state.passwordError && 
                                    <div class={style.errorMessage}><I18n>LoginErrorIncorrectCredentials</I18n></div>
                                }
                                {this.state.emailError && 
                                    <div class={style.errorMessage}><I18n>LoginErrorEnterCredentials</I18n>.</div>
                                }
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={{sm:24}}>
                            <Button type="submit" spinner={this.props.loading.Login}>
                                <I18n>
                                    login
                                </I18n>
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Form>
        )
    }
}


// WEBPACK FOOTER //
// ./components/partials/Login/index.js